// extracted by mini-css-extract-plugin
export var item = "fj_tw";
export var text = "fj_hs";